import { useTranslations } from "next-intl";
import { memo } from "react";
import ThemeButton from "src/components/button/ThemeButton";
import BlackSpinIcon from "src/components/icon/BlackSpinIcon";
import { Product } from "src/types/storefront";

type Props = {
  loading: boolean;
  product?: Product;
  disabled?: boolean;
};

function AddToCart({ loading, disabled = false }: Props) {
  const t = useTranslations("ProductOverview");

  return (
    <div className="flex flex-1">
      {/* #add-to-cart id is added for e2e testing */}
      <ThemeButton
        type="submit"
        id="add-to-cart"
        className="w-full"
        containerClassname="flex flex-1 flex-col"
        disabled={disabled}
      >
        {loading && <BlackSpinIcon className="-ms-1 me-3" />}
        {loading ? t("adding") : t("add_to_bag")}
      </ThemeButton>
    </div>
  );
}

export default memo(AddToCart);
